import { PairedCostAdjustments } from '@aloft/toolkit-shared';

import { get } from 'lodash';

import { Tkv2OrderContext } from '../../../../controller/types.js';

export const getAdjustmentTooltip = (
  context: Tkv2OrderContext,
  compID: string,
  adjustmentKey: keyof PairedCostAdjustments,
): { calculations?: string[]; description?: string } | undefined => {
  return {
    calculations: get(
      context,
      `pairedCostResults.comps.${compID}.adjustments.${adjustmentKey}.calculations`,
    ),
    description: get(
      context,
      `pairedCostResults.comps.${compID}.adjustments.${adjustmentKey}.description`,
    ),
  };
};
